export const CoolerType = {
	other: 0,
	cooler: 1,
	freezer: 2,
};
